import { useState } from 'react'
import Card from '../Reusable/Card'
import Button from '../Reusable/Button'
import UnControlSwitch from '../Reusable/Form/Switch'
import toggleInputType from "../../assets/toggleInputType.png";
import APIS from '../../constant/EndPoint';
import useGetHook from '../../customHooks/useAPIServiceGetHook';
import usePostHook from '../../customHooks/useAPIServicePostHook';


const APIIntegration = (props: any) => {
  const {profile} = props
  console.log(profile)
  const { data: apiData, refetch } = useGetHook({
    queryKey: [`merchant-api`],
    url: APIS.API_KEY,
    params: {
      user: profile?.user
    },
  });

  const { mutateAsync: createNewAPI, isPostLoading } = usePostHook({
    queryKey: ["merchant-api"],
    navigateURL: "",
  });

  const { mutateAsync: toggleIsActive } = usePostHook({
    queryKey: ["merchant-api"],
    navigateURL: "",
  });

  const { mutateAsync: toggleIsTest } = usePostHook({
    queryKey: ["merchant-api"],
    navigateURL: "",
  });

  const handleCreateNewAPI = async (values: any) => {
    const url = APIS.API_KEY;
    let formData = {
      user: profile.user
    };
    try {
      await createNewAPI({ url, formData });
    } catch (err) {
      console.log(err);
    }
  };

  const handleToggleIsActive = async (values: any) => {
    const url = `${APIS.API_KEY}toggle-is-active/?user=${profile.user}`;
    let formData = {};
    try {
      await toggleIsActive({ url, formData });
    } catch (err) {
      console.log(err);
    }
  };

  const handleToggleIsTest = async (values: any) => {
    const url = `${APIS.API_KEY}toggle-is-test/?user=${profile.user}`;
    let formData = {};
    try {
      await toggleIsTest({ url, formData });
    } catch (err) {
      console.log(err);
    }
  };
  const [isPasswordType, setIsPasswordType] = useState(true);
  const [isPasswordType2, setIsPasswordType2] = useState(true);
  return (
    <>
      <Card title={"API KEY"}>
        <div className='m-2'>
          <div className="w-full my-2 text-left relative mt-4">
            <div className='relative'>
              <p>Access Key</p>
              <input
                defaultValue={apiData?.access_key}
                type={isPasswordType ? "password" : "text"}
                disabled={true}
                className="w-full focus:outline-none bg-[#EEF5F4] p-2 mt-1"
              />
              <img
                src={toggleInputType}
                onClick={() => setIsPasswordType(!isPasswordType)}
                alt="toogle input type"
                className="absolute bottom-[10px] right-[10px] cursor-pointer"
              />
            </div>
            <div className='relative mt-6'>
              <p>Secret Key</p>
              <input
                defaultValue={apiData?.secret_key}
                type={isPasswordType ? "password" : "text"}
                disabled={true}
                className="w-full focus:outline-none bg-[#EEF5F4] p-2 mt-1"
              />
              <img
                src={toggleInputType}
                onClick={() => setIsPasswordType2(!isPasswordType2)}
                alt="toogle input type"
                className="absolute bottom-[10px] right-[10px] cursor-pointer"
              />
            </div>

          </div>
          <div className='flex gap-x-8 mt-4'>
            <div className='flex gap-x-8'>
              <p>Test Mode</p>
              <UnControlSwitch
                value={apiData?.is_active}
                onChange={handleToggleIsActive}
              />
            </div>
            <div className='flex gap-x-8'>
              <p>Active Status</p>
              <UnControlSwitch
                value={apiData?.is_test}
                onChange={handleToggleIsTest}
              />
            </div>
          </div>
          <div className='w-full flex justify-between'>
            <div className='w-[150px] mt-6'>
              <Button
                label={"Generate New Key"}
                onClick={handleCreateNewAPI}
                isLoading={isPostLoading}
              />
            </div>
          </div>
        </div>
      </Card>
      {/* <Card title='Documentations'>
        <p>Coming Soon</p>
      </Card> */}
    </>

  )
}

export default APIIntegration
